import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useSupplierGroupDetails = (groupId: string) => {
    return useQuery(queries.supplierGroups.detail(groupId));
};
